module.exports = __webpack_public_path__ + "static/media/support.c58d879a.svg";